import {defineStore} from 'pinia';
import {useThemeStore} from "@js/store/ThemeStore.js";

export const usePopupsControlStore = defineStore('popupsControlStore', {
    state: () => ({
        isErrorPopupVisible: false,
        citySelectPopupVisible: false,
        selectedCity: {name: 'Москва', lat: 55.7558, lng: 37.6173},
    }),
    actions: {
        showCitySelectPopup() {
            this.citySelectPopupVisible = true
            const themeStore = useThemeStore()
            themeStore.setBodyOverflow(true)
        },
        closeCitySelectPopup() {
            this.citySelectPopupVisible = false
            const themeStore = useThemeStore()
            themeStore.setBodyOverflow(false)
        },
        showErrorPopup() {
            this.isErrorPopupVisible = true
        },
    }
});
